// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"494": "40775784","5111": "69f5c5ab","9988": "b78b2a24",}[chunkId] + ".css"
}